import React from 'react';
import { Button, Card, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Works.css';

const Works = (props) => {
    const {id, img, title} = props.works
    return (
        <>
            <div className="col-md-3">
                <Col className="card-container">
                    <Card className="h-100 border-0 card-border position-relative my-3 works-card">
                        <Card.Img variant="top" className="img-fluid border-0 card-img" src={img} />

                        <div className="position-absolute bottom-0 left-0 w-100 text-center py-2 text-white" style={{ backgroundImage: 'linear-gradient(90deg,#f61b10,#ef0963)' }}>
                            <Card.Title>{title}</Card.Title>
                        </div>
                        <div className="middle">
                            <div className="card-btn">
                                <Link to={`/singleworks/${id}`} className="details-link">
                                    <Button style={{ backgroundImage: 'linear-gradient(90deg,#f61b10,#ef0963)', border: 'none' }} className="text-btn fs-6 fw-bold">
                                        See Details
                                    </Button>
                                </Link>
                            </div>
                        </div>

                    </Card>
                </Col>
            </div>
                        
        </>
    );
};

export default Works;